import { Alert, AlertTitle, Button } from '@mui/material';

interface ErrorStateProps {
  message: string;
  onRetry?: () => void;
}

export function ErrorState({ message, onRetry }: ErrorStateProps) {
  return (
    <Alert
      severity="error"
      role="alert"
      sx={{ my: 3 }}
      action={
        onRetry ? (
          <Button color="inherit" size="small" onClick={onRetry} aria-label="Riprova l'operazione">
            Riprova
          </Button>
        ) : undefined
      }
    >
      <AlertTitle>Si è verificato un errore</AlertTitle>
      {message}
    </Alert>
  );
}
